import { useState } from "react";
import I18n from "common/i18n";
import { usePlaySound } from "common/utils";
import { ContactActionBar } from "./ContactActionBar";
import { ContactInputBar } from "./contact/ContactInputBar";

enum ContactBottomState {
  INPUT = "input",
  CARD_OPEN = "card_open",
  CARD_CLOSED = "card_closed",
}

export const ContactBottomBar = ({ visible }: { visible: boolean }) => {
  const play = usePlaySound();
  const [state, setState] = useState<ContactBottomState>(ContactBottomState.INPUT);

  if (!visible) return null;

  const handleOpenCard = () => {
    setState(ContactBottomState.CARD_OPEN);
  };

  const handleBackToInput = () => {
    play();
    setState(ContactBottomState.INPUT);
  };

  const handleToggleCard = () => {
    play();
    setState((prev) =>
      prev === ContactBottomState.CARD_OPEN
        ? ContactBottomState.CARD_CLOSED
        : ContactBottomState.CARD_OPEN,
    );
  };

  if (state === ContactBottomState.INPUT) {
    return <ContactInputBar onShowCard={handleOpenCard} />;
  }

  return (
    <div className="flex-col-el w-full bg-white">
      {state === ContactBottomState.CARD_OPEN && <ContactActionBar visible={true} />}
      <div className="flex-col-el px-4 pt-2 pb-4 w-full bg-white">
        <div className="flex-row-el items-center gap-3">
          <button
            onClick={handleBackToInput}
            className="flex-col-el flex-center shrink-0 cursor-pointer border-2 border-solid active:opacity-70 rounded-lg w-[52px] h-[52px] transition-colors bg-white border-blue-60 hover:bg-blue-20"
          >
            <span className="material-symbols-outlined type-title text-blue-100">keyboard</span>
          </button>
          <button
            onClick={handleToggleCard}
            className="flex-row-el flex-1 items-center justify-center gap-1 border-none bg-transparent cursor-pointer active:opacity-70 p-0"
          >
            <span className="material-symbols-outlined type-hero text-textcolor-black">
              {state === ContactBottomState.CARD_OPEN ? "expand_less" : "expand_more"}
            </span>
            <p className="type-text type-title text-textcolor-black">
              {I18n.t("MSG_USER_PROFILE_MESSAGE_MENU")}
            </p>
          </button>
        </div>
      </div>
    </div>
  );
};
